import React from 'react';

import requestAPI from 'helpers/requestAPI';

import { toastSuccess, toastError } from '../../../utils/toastr';
import { Button, Input, Modal } from 'antd';

const Add = () => {
  const [ isModalVisible, setIsModalVisible ] = React.useState(false);
  const [ formState, setFormState ] = React.useState({
		name: '',
		server: '',
		port: '',
		username: '',
		password: ''
  });

  const toggleModalVisibility = React.useCallback(() => setIsModalVisible(isVisible => !isVisible), [setIsModalVisible]);

  const handleFormChange = React.useCallback(event => {
    const { name, value } = event.target;
    setFormState((prevState) => ({ ...prevState, [name]: value }))
  }, [setFormState]);
  
  const sendData = React.useCallback(() => {
		const params = {
			routeParams: {
				route: 'servers'
			},
			method: 'post',
			data: formState
		};

		requestAPI(params)
    .then(response => {
      toastSuccess(response.data.ms);
      toggleModalVisibility();
    })
    .catch(error => {
      toastError(error);
    });
  }, [formState, toggleModalVisibility]);

	return (
		<div className="add">
      <Button size={'small'} onClick={toggleModalVisibility}>Add new server</Button>
      <Modal
        title="Add server"
        visible={isModalVisible}
        onOk={sendData}
        onCancel={toggleModalVisibility}
      >
        <div className="add__items">
          <div className="add__items__item add__items__item--name">
            <div className="add__items__item__title">Name server:</div>
            <Input
              value={formState.name}
              onChange={handleFormChange}
              name="name"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--ftp-server">
            <div className="add__items__item__title">FTP-address server:</div>
            <Input
              value={formState.server}
              onChange={handleFormChange}
              name="server"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--port">
            <div className="add__items__item__title">Port server:</div>
            <Input
              value={formState.port}
              onChange={handleFormChange}
              name="port"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--username">
            <div className="add__items__item__title">Username:</div>
            <Input
              value={formState.username}
              onChange={handleFormChange}
              name="username"
              type="text"
              className="add__items__item__input"
            />
          </div>

          <div className="add__items__item add__items__item--password">
            <div className="add__items__item__title">Password:</div>
            <Input
              value={formState.password}
              onChange={handleFormChange}
              name="password"
              type="text"
              className="add__items__item__input"
            />
          </div>
        </div>
      </Modal>
		</div>
	);
};

export default Add;
